const initServiceMixin = {
  created () {
    if (typeof this.service === 'function') {
      // eslint-disable-next-line
      this.service = new this.service()
      if (this.hasOwnProperty('object')) {
        if (this.service.hasOwnProperty('__itemTemplate') && typeof this.service.__itemTemplate === 'object') {
          this.object = Object.assign({}, this.service.__itemTemplate)
        }
      }
    }
    if (typeof this.services === 'object') {
      for (let s in this.services) {
        if (typeof this.services[s] === 'function') {
          this.services[s] = new this.services[s]()
        }
      }
    }
  }
}

export default initServiceMixin
